import React, { Component } from 'react';
import dynamicPortal from '../utils/dynamicPortal';
import ReisadviesPrices from '../components/Reisadviezen/Prices';

export class ReisadviesPricesPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-reisadvies-prices', (config) => <ReisadviesPrices config={config} />);
  }
}

export default ReisadviesPricesPortal;



// WEBPACK FOOTER //
// ./src/portals/ReisadviesPricesPortal.js